import { render } from "./ProfileFriendNavigation.vue?vue&type=template&id=37e8af22&scoped=true"
import script from "./ProfileFriendNavigation.vue?vue&type=script&lang=js"
export * from "./ProfileFriendNavigation.vue?vue&type=script&lang=js"

import "./ProfileFriendNavigation.vue?vue&type=style&index=0&id=37e8af22&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e8af22"]])

export default __exports__